export default __webpack_public_path__ + "static/media/14_1.df1a4d30.jpg";